import { ICashbackHistoryFilters, IGetBonusHistoryFilters } from 'shared/models/BonusSystem'
import { BonusPromotionStatus, IGetUserPromotionsFilters } from 'shared/models/Promotion'
import { deleteEmptyFields } from 'shared/utils/filters'

import { BaseHttpService } from '../BaseHttpService'
import { QueryTypes } from '../data'
import { BonusSystem } from './BonusSystemConverter'

class BonusSystemApi extends BaseHttpService {
  private converter

  constructor(baseUrl: string) {
    super(baseUrl)
    this.baseUrl = `${baseUrl}/api/bonus-system`
    this.converter = new BonusSystem()
  }

  async exchangeBonusBalanceToBalance({ amount }: { amount: number }) {
    return this.sendQuery({
      url: `${this.baseUrl}/bonusbalance-to-balance/`,
      type: QueryTypes.POST,
      data: { amount },
    })
  }

  async loadCashbackHistory(filters: ICashbackHistoryFilters) {
    const filtersWithFields = deleteEmptyFields(filters)

    return this.sendQuery({
      url: `${this.baseUrl}/cashback/history`,
      type: QueryTypes.GET,
      data: filtersWithFields,
      converterSuccess: this.converter.convertBonusHistory,
    })
  }

  async loadBonusHistory(filters: IGetBonusHistoryFilters) {
    const filtersWithFields = deleteEmptyFields(filters)

    return this.sendQuery({
      url: `${this.baseUrl}/bonusbalance/history`,
      type: QueryTypes.GET,
      data: filtersWithFields,
      converterSuccess: this.converter.convertBonusHistory,
    })
  }

  async getUserPromotions(filters: IGetUserPromotionsFilters) {
    if (filters.polling) {
      return this.sendQuery({
        url: `${this.baseUrl}/promotions/user/?page=1&page_size=10`,
        data: {
          status: [
            BonusPromotionStatus.active,
            BonusPromotionStatus.available,
            BonusPromotionStatus.available_completed,
            BonusPromotionStatus.completed,
          ],
        },
        type: QueryTypes.GET,
        converterSuccess: this.converter.convertUserPromotions,
      })
    }

    const filtersWithFields = deleteEmptyFields(filters)

    return this.sendQuery({
      url: `${this.baseUrl}/promotions/user/`,
      type: QueryTypes.GET,
      data: filtersWithFields,
      converterSuccess: this.converter.convertUserPromotions,
    })
  }

  async getMoneyFromPromotion({ id }: { id: string }) {
    return this.sendQuery({
      url: `${this.baseUrl}/promotions/user/promotion/${id}/pay`,
      type: QueryTypes.POST,
      converterSuccess: this.converter.convertUserPromotionItem,
    })
  }

  async changeActiveUserPromotion({ id }: { id: string }) {
    return this.sendQuery({
      url: `${this.baseUrl}/promotions/change-active/${id}`,
      type: QueryTypes.POST,
    })
  }
}

export default BonusSystemApi
